import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ChakraProvider } from '@chakra-ui/react'
import { LyricsThemeProvider } from './context/LyricsThemeContext.tsx';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { Buffer } from 'buffer';
import { setupCSP } from './utils/cspHandler';

// Set up Content Security Policy based on environment
setupCSP();

// Polyfill Buffer for Apple MusicKit
window.Buffer = Buffer;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChakraProvider>
      <Router>
        <AuthProvider>
          <LyricsThemeProvider>
            <App />
          </LyricsThemeProvider>
        </AuthProvider>
      </Router>
    </ChakraProvider>
  </React.StrictMode>,
)
